import SygdomCarousel from "../SygdomCarousel/SygdomCarousel";

export default function Frasebiblotek() {
  return (
    <div className="mx-auto grid grid-cols-1 pt-[20px] md:pt-20 border-b md:border-none md:grid-cols-2 md:py-32 mx-auto items-center gap-4 items-start container pb-[30px] md:pb-[40px] mb-8 md:pb-0 ">
      <div className="md:mb-0 md:container order-2 md:order-1">
        <h2 className="text-dxl md:text-d2xl font-bold text-doctio-green">
          Stort frasebibliotek
        </h2>
        <p>
          Doctio tilbyder et stort og bredt funderet bibliotek af fraser inden
          for forskellige sygdomme, diagnoser, symptomer, procedurer,
          årskontroller, rutinekontroller samt “del-fraser” inden for den
          objektive undersøgelse, ordinationer, informationer etc. Alle fraser
          er skrevet og gennemgået af minimum to læger og andet relevant
          sundhedspersonale. Udvalgte fraser vil løbende blive
          speciallægevalideret for at opnå den højeste faglige kvalitet. Doctio
          gør det muligt at have dine personlige fraser lige ved hånden - uanset
          system eller arbejdsplads. Vores webapplikation er uafhængig af
          journalsystemer.
        </p>
        <a href="/signup" className="text-doctio-green font-bold">
          Prøv det gratis
        </a>
      </div>

      <div className="flex justify-center pl-0 md:container order-1 md:order-2">
        <SygdomCarousel />
      </div>
    </div>
  );
}
